<template>
  <div class="col-12 px-0 common-col-card">
    <div class="row mx-0 py-1">
      <template v-if="!typePackage">
        <div class="col-3 col-md-2 col-lg-2 col-xl-2 col-xxl-3 px-3">
          <div class="mx-auto my-2" :class="colTitle">
            <p class="m-0 common-col-card-title" :class="colTitleTop">
              <slot v-if="$slots['col-title-top']" name="col-title-top"></slot>
            </p>
            <p class="m-0 common-col-card-title" :class="colTitleBottom">
              <slot
                v-if="$slots['col-title-bottom']"
                name="col-title-bottom"
              ></slot>
            </p>
          </div>
        </div>
        <div
          class="col-9 col-md-10 col-lg-10 col-xl-10 col-xxl-9 ps-0 pe-3 my-auto"
        >
          <slot v-if="$slots['col-title-body']" name="col-title-body"></slot>
        </div>
      </template>
      <template v-else>
        <div class="col-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2 px-3">
          <slot
            v-if="$slots['col-package-img']"
            name="col-package-img"
          ></slot>
        </div>
        <div class="col-3 col-md-2 col-lg-2 col-xl-2 col-xxl-3 px-3">
          <div class="mx-auto my-2" :class="colTitle">
            <p class="m-0 common-col-card-title" :class="colTitleTop">
              <slot v-if="$slots['col-title-top']" name="col-title-top"></slot>
            </p>
            <p class="m-0 common-col-card-title" :class="colTitleBottom">
              <slot
                v-if="$slots['col-title-bottom']"
                name="col-title-bottom"
              ></slot>
            </p>
          </div>
        </div>
        <div
          class="col-7 col-md-8 col-lg-8 col-xl-8 col-xxl-7 ps-0 pe-3 my-auto"
        >
          <slot v-if="$slots['col-title-body']" name="col-title-body"></slot>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    typePackage: {
      type: Boolean,
      default: false,
    },
    colTitle: {
      type: Object,
      default: {},
    },
    colTitleTop: {
      type: Object,
      default: {},
    },
    colTitleBottom: {
      type: Object,
      default: {},
    },
  },
};
</script>

<style>
.common-col-card {
  font-size: 1.125rem;
  color: #000000;
  border: 1px solid rgb(204, 204, 204);
}
.common-col-card-title {
  height: 40.5px;
  line-height: 40.5px;
  overflow-x: auto;
}
.common-col-card-title::-webkit-scrollbar {
  display: none;
}
</style>
